import { createContext, useState, useContext, useEffect } from 'react';
import apiClient from './apiClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const verifySession = async () => {
      try {
        const response = await apiClient.get('/auth.php?action=verify');
        if (response.data.success) {
          setIsAuthenticated(true);
          setUser({
            email: response.data.user.email,
            role: response.data.user.role,
            id: response.data.user.id,
            nome: response.data.user.nome,
            cognome: response.data.user.cognome,
          });
        } else {
          setIsAuthenticated(false);
          setUser(null);
        }
      } catch (error) {
        console.error('Errore durante la verifica della sessione:', error);
        setIsAuthenticated(false);
        setUser(null);
      }
    };

    verifySession();
  }, []);

  const login = async (email, role, id) => {
    try {
      const response = await apiClient.post('/users.php?action=getUserDetails', {
        userIds: [id],
      });
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const userDetails = response.data[0];
        const { nome, cognome } = userDetails;
        setIsAuthenticated(true);
        setUser({ email, role, id, nome, cognome });
      } else {
        console.error('Errore nel recupero dei dati utente: Nessun dato trovato');
        setIsAuthenticated(true);
        setUser({ email, role, id });
      }
    } catch (error) {
      console.error('Errore durante il recupero dei dati utente:', error);
      setIsAuthenticated(true);
      setUser({ email, role, id });
    }
  };

  const logout = async () => {
    try {
      await apiClient.post('/auth.php?action=logout');
      setIsAuthenticated(false);
      setUser(null);
    } catch (error) {
      console.error('Errore durante il logout:', error);
    }
  };

  const getUserId = () => user?.id;

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, getUserId }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);